import React, { useEffect, useMemo, useState } from "react";
import apiClient from "../apiClient";
import { Link } from "react-router-dom";

const Subcategories = () => {
    const [subcategories, setSubcategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const groupedSubcategories = useMemo(() => {
      const seededGroups = categories.reduce((acc, category) => {
        acc[category.Description] = [];
        return acc;
      }, {});

      const groups = subcategories.reduce((acc, item) => {
        const categoryName = item.CategoryDescription || "Uncategorized";
        if (!acc[categoryName]) acc[categoryName] = [];
        acc[categoryName].push(item);
        return acc;
      }, seededGroups);

      return Object.keys(groups)
        .sort((a, b) => a.localeCompare(b))
        .map((categoryName) => ({
          categoryName,
          items: groups[categoryName].sort((a, b) =>
            (a.SubcategoryDescription || "").localeCompare(b.SubcategoryDescription || "")
          ),
        }));
    }, [categories, subcategories]);

    useEffect (() => {
        const fetchAllSubcategories = async () => {
            try {
                const [subcategoriesRes, categoriesRes] = await Promise.all([
                  apiClient.get("/subcategories"),
                  apiClient.get("/categories"),
                ]);
                setSubcategories(Array.isArray(subcategoriesRes.data) ? subcategoriesRes.data : []);
                setCategories(Array.isArray(categoriesRes.data) ? categoriesRes.data : []);
            } catch (err) {
                setError("Failed to load subcategories.");
            } finally {
                setLoading(false);
            }
        };
        fetchAllSubcategories();
    }, []);

    const handleDelete = async (subcategoryId) => {
        try {
          await apiClient.delete(`/subcategories/${subcategoryId}`);
          setSubcategories((prev) => prev.filter((item) => item.SubcategoryId !== subcategoryId));
        } catch (err) {
          setError("Delete failed. Please try again.");
        }
      };

    return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Subcategories</h1>
          <p className="page-subtitle"><Link to="/">Home</Link> / Subcategories</p>
        </div>
        <Link className="btn-link" to="/SubcategoriesAdd">Add Subcategory</Link>
      </header>

      {error && <p className="notice notice-error">{error}</p>}
      {loading && <p className="notice notice-muted">Loading subcategories...</p>}

      {!loading && (
        <section className="resource-list">
          {groupedSubcategories.length === 0 ? (
            <p className="notice notice-muted">No subcategories yet.</p>
          ) : (
            groupedSubcategories.map((group) => (
              <div key={group.categoryName} className="panel page-cta">
                <h2>{group.categoryName}</h2>
                <div className="resource-list">
                  {group.items.length === 0 ? (
                    <p className="notice notice-muted">No subcategories assigned yet.</p>
                  ) : (
                    group.items.map((subcategory) => (
                      <article key={subcategory.SubcategoryId} className="resource-row">
                        <div>
                          <strong>{subcategory.SubcategoryDescription}</strong>
                        </div>
                        <div className="actions">
                          <button className="btn btn-danger" onClick={() => handleDelete(subcategory.SubcategoryId)}>Delete</button>
                          <Link className="btn-link" to={`/SubcategoriesUpdate/${subcategory.SubcategoryId}`}>Update</Link>
                        </div>
                      </article>
                    ))
                  )}
                </div>
              </div>
            ))
          )}
        </section>
      )}
    </div>
    );
};

export default Subcategories;
